export enum IProductIconNames {
  Bestseller = 'bestseller',
  Blackfriday = 'blackfriday',
  Stock = 'stock',
  Popularity = 'popularity',
  Discount = 'discount',
  Curation = 'curation',
  Promotion = 'promotion',
  isNew = 'isNew',
  Trending = 'trending',
  GenderMens = 'gender-mens',
  GenderWomens = 'gender-womens',
  GenderUnisex = 'gender-unisex',
}
